import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgThermostaatLager = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
    />
    <path
      fill="#FFBFA5"
      d="M20 32.5c6.904 0 12.5-5.596 12.5-12.5S26.904 7.5 20 7.5 7.5 13.096 7.5 20 13.096 32.5 20 32.5"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.18 8.006a11.9 11.9 0 0 0-5.934 1.54l-.492-.871A12.9 12.9 0 0 1 33 19.889v.004a12.7 12.7 0 0 1-.52 3.519l-.96-.284c.312-1.052.473-2.142.48-3.239A11.9 11.9 0 0 0 20.18 8.006"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="m14.5 13.87 2.68 4.24h-5.36zm0-1.87L10 19.11h9zM19 20.89 14.5 28 10 20.89z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m16.21 26.216 2.628-4.144.844.536-3.472 5.476-1.942-3.067.844-.534z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="m22.6 19.17-1 .61-.6-.94 1.73-1.37h1.21v4.78H22.6zM24.69 20.92a1.14 1.14 0 0 1 .74-1.13 1.08 1.08 0 0 1-.53-1c0-.75.6-1.36 1.68-1.36s1.68.61 1.68 1.36a1.08 1.08 0 0 1-.53 1 1.14 1.14 0 0 1 .74 1.13c0 .85-.67 1.42-1.89 1.42s-1.89-.57-1.89-1.42m2.38-.21a.44.44 0 0 0-.49-.48.45.45 0 0 0-.5.48.46.46 0 0 0 .5.49.45.45 0 0 0 .49-.49m0-1.71a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M28.79 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1.39 0a.398.398 0 0 0-.395-.463.4.4 0 0 0-.395.463.4.4 0 1 0 .79 0"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgThermostaatLager);

export default ForwardRef;
